import { UseFormReturn } from "react-hook-form";

import { useTranslation } from "../../core/translation.core";
import useRewardQuery from "../../hooks/useRewardQuery.hook";
import ErrorCenterIcon from "../../icons/exclamationTriangleCenter.icon";
import LoadingOvalCenterIcon from "../../icons/loadingOvalCenter.icon";
import { RewardListFilter } from "../../types/reward";
import RewardListRow from "./rewardRow.comp";
import NoRecordDisplay from "../common/noRecord.comp";
import { ListSection } from "../reuseables/list.comp";
import Link from "next/link";

export default function RewardListComp({ methods, customerId }: { methods: UseFormReturn<RewardListFilter, any>, customerId?: string | string[] }) {
  const { t, msg } = useTranslation();
  const { data: rewards, isLoading, isError, error } = useRewardQuery(methods);

  const orderClass = "grow shrink basis-4/12";
  const pointClass = "grow shrink basis-1/12";
  const baseClass = "grow shrink basis-1/12";

  if (isError) return <ErrorCenterIcon reason={error.message} />;
  if (isLoading) return <LoadingOvalCenterIcon />;

  return (
    <>
     {rewards && rewards.list.length > 0 &&  <Link className="underline email" href={`/rewards?customerId=${customerId}`}>
        {t(msg.customer.viewAllRewards)}
      </Link>}
      <ListSection>
        <div id="product-section" className="pt-6 lg:pt-0">
          <div className="hidden lg:grid lg:grid-cols-6 gap-6 px-6 py-3 text-sm font-medium">
            <div className={orderClass}>{t(msg.order.orderNumber)}</div>
            <div className={baseClass}>{t(msg.reward.purchaseDate)}</div>
            <div className={baseClass}>{t(msg.reward.expiresOn)}</div>
            <div className={baseClass}>{t(msg.general.name)}</div>
            <div className={baseClass}>{t(msg.reward.rewardStatus)}</div>
            <div className={pointClass}>{t(msg.reward.points)}</div>
          </div>

          {(rewards && rewards.list.length > 0) ? 
          rewards.list.map((r) => (
            <RewardListRow reward={r} key={r.id} />
          )) :
            <NoRecordDisplay />
          }
        </div>
      </ListSection>
    </>
  );
}
